import I18n from "i18n-js";
import { makeImmutable, toPairs } from "../../core";
import { CheckboxFieldControler, ErrorBox } from "../../form";
export class ConsentsFormControler {
    constructor(params) {
        this.consents = params.consents;
        this.tosAgreement = new CheckboxFieldControler({
            initialValue: this.consents.tosAgreement,
            update: (value) => (this.consents.tosAgreement = value),
            errorBox: new ErrorBox({
                domainObjects: [this.consents],
                errorMessages: {
                    TermsOfServiceNotAccepted: I18n.t("t.activerecord.errors.models.user.attributes.tos_agreement.invalid"),
                },
            }),
        });
        this.subscribeEmail = new CheckboxFieldControler({
            initialValue: this.consents.subscribeEmail,
            update: (value) => {
                this.consents.subscribeEmail = value;
                this.updateMarketingConsent();
            },
        });
        this.subscribePhone = new CheckboxFieldControler({
            initialValue: this.consents.subscribePhone,
            update: (value) => {
                this.consents.subscribePhone = value;
                this.updateMarketingConsent();
            },
        });
        this.marketingConsent = new CheckboxFieldControler({
            initialValue: this.consents.subscribeEmail || this.consents.subscribePhone,
            update: (value) => {
                this.subscribeEmail.onChange(value);
                this.subscribePhone.onChange(value);
            },
        });
        makeImmutable(this);
    }
    touch() {
        toPairs(this.fields).forEach(([, field]) => field.onBlur());
    }
    updateMarketingConsent() {
        this.marketingConsent.setValueWithoutUpdate(this.consents.subscribeEmail || this.consents.subscribePhone);
    }
    get fields() {
        return {
            tosAgreement: this.tosAgreement,
            marketingConsent: this.marketingConsent,
            subscribeEmail: this.subscribeEmail,
            subscribePhone: this.subscribePhone,
        };
    }
}
